import styled from '@emotion/styled'
import { ScopeUser } from '@pubstack/common/src/user'
import { useAtomValue } from 'jotai'
import { FunctionComponent } from 'react'
import { useDeleteUser } from '~/api/app/user.api'
import Button from '~/components/Button'
import { useGlobalModal } from '~/components/layout/GlobalModal'
import { Modal } from '~/components/Modal'
import { currentScopeState } from '~/state'
import { WithClassName } from '~/types/utils'

const Paragraphs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  & > * {
    display: inline-flex;
    flex-direction: column;
  }
`
type SettingsMembersPageDeleteModalProps = WithClassName & { member: ScopeUser }
export const SettingsMembersPageDeleteModal: FunctionComponent<SettingsMembersPageDeleteModalProps> = ({ member }) => {
  const { mutateAsync: deleteUser } = useDeleteUser(member.email, {
    successToast: (
      <>
        <strong>{member.nickname}</strong>&#39;s access has been revoked.
      </>
    ),
    errorToast: "An error occurred while trying to revoke this user's access.",
  })
  const { close } = useGlobalModal()
  const scope = useAtomValue(currentScopeState)
  return (
    <Modal.Content>
      <Modal.Title>Remove member</Modal.Title>

      <Modal.Body>
        <Paragraphs>
          <p>
            <span>
              You are about to revoke{' '}
              <strong>
                {member.nickname}'s ({member.email})
              </strong>{' '}
              access.
            </span>
            <span>This person will not be able to connect to {scope.name} anymore.</span>
          </p>
          <p>Do you confirm your choice ?</p>
        </Paragraphs>
      </Modal.Body>

      <Modal.Actions>
        <Button onClick={close} variant={'tertiary'} trackingLabel={'common-settings-members-icon-deletion-cancel'}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            deleteUser()
            close()
          }}
          variant={'negative'}
          trackingLabel={'common-settings-members-icon-deletion-confirm'}
        >
          Remove member
        </Button>
      </Modal.Actions>
    </Modal.Content>
  )
}
